class Controller {
  constructor($injector, $timeout, Sections) {
    "ngInject";

    this.User = $injector.get("User");
    this.UserVerificationsTransforms = $injector.get(
      "UserVerificationsTransforms"
    );
    this.sections = Sections.settingsSections;
    this.$timeout = $timeout;

    this.code = {
      verificationCode: "9630",
      expiryDate: "1530540379",
    };

    this.userInfo = {
      isVerified: false,
      isExisting: false,
      isBlocked: false,
    };

    this.hadRequest = false;
    this.isChecking = false;
    this.tokenCopied = false;
    this.activeTab = "phone";
  }

  $onInit() {}

  toggleChecking(status) {
    this.isChecking = status || !this.isChecking;
  }

  checkVerification(type) {
    const verifyUser =
      type === "phone"
        ? this.User.verificationCode({ phone: this.phone })
        : this.User.verificationEmail({ email: this.email });

    this.toggleChecking();
    verifyUser.$promise.then(
      (response) => {
        if (response.is_verified) {
          this.user = {
            phone: this.phone,
            email: this.email,
            ...response.user,
          };
          this.userInfo.isExisting = true;
          this.userInfo.isVerified = true;
        } else {
          this.user = { phone: this.phone, email: this.email };
          this.code = { ...response };
          this.userInfo.isExisting = true;
          this.userInfo.isVerified = false;
          this.userInfo.isBlocked = response.is_blocked_phone;
          this.code = this.UserVerificationsTransforms.justify(response);
        }
        this.toggleChecking();
        this.hadRequest = true;
      },
      () => {
        this.user = { phone: this.phone, email: this.email };
        this.toggleChecking();
        this.userInfo.isExisting = false;
        this.hadRequest = true;
      }
    );
  }

  resendVerification(type) {
    const resendVerify =
      type === "phone"
        ? this.User.resendVerification({ phone: this.phone })
        : this.User.resendVerificationEmail({ email: this.email });

    resendVerify.$promise.then(
      () => {
        this.checkVerification(type);
      },
      () => {}
    );
  }

  unblockPhone() {
    const unblockPhone = this.User.unblockPhone({ phone: this.phone });

    unblockPhone.$promise.then(
      () => {
        this.checkVerification("phone");
      },
      () => {}
    );
  }

  selectTab(type) {
    this.activeTab = type;
    this.hadRequest = false;
    this.userInfo = {
      isVerified: false,
      isExisting: false,
    };
  }

  onSuccess() {
    this.tokenCopied = true;

    this.$timeout(() => {
      this.tokenCopied = false;
    }, 1000);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/userVerifications/userVerifications.controller.js